import { StripeCheckFailure } from '../domains/a-connect-account-no-retry-can-fix';

/**
 * `check_failed` means the API could not ask Stripe, so nobody knows where
 * this organizer stands. It used to be reported as `in_progress`, which read
 * as a normal wait and hid three different outages. See DEV-157.
 */
export type OnboardingStatus = 'not_started' | 'in_progress' | 'complete' | 'needs_info' | 'check_failed';

export interface StripeConnectRequirements {
  currentlyDue: string[];
  eventuallyDue: string[];
  pastDue: string[];
}

export interface StripeConnectStatus {
  status: OnboardingStatus;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
  requirements: StripeConnectRequirements;
  accountId?: string;
  /**
   * Which failure, when `status` is 'check_failed'. Absent from an API that
   * predates the field, and absent when the API failed before it ever asked
   * Stripe, so every reader treats absence as the outage.
   */
  checkFailure?: StripeCheckFailure;
}

export class CheckStripeConnectStatusAction {
  static readonly type = '[StripeConnect] CheckStripeConnectStatusAction';
}

export class SetStripeConnectStatusAction {
  static readonly type = '[StripeConnect] SetStripeConnectStatusAction';

  constructor(public readonly payload: StripeConnectStatus) {}
}

export class StartOnboardingAction {
  static readonly type = '[StripeConnect] StartOnboardingAction';
}

export class SetOnboardingUrlAction {
  static readonly type = '[StripeConnect] SetOnboardingUrlAction';

  constructor(public readonly payload: { url: string; expiresAt: number }) {}
}

export class CompleteOnboardingAction {
  static readonly type = '[StripeConnect] CompleteOnboardingAction';
}

export class LoadOnboardingStatusAction {
  static readonly type = '[StripeConnect] LoadOnboardingStatusAction';
}

export class SetStripeConnectErrorAction {
  static readonly type = '[StripeConnect] SetStripeConnectErrorAction';

  constructor(public readonly payload: string | null) {}
}

export class ResetStripeConnectStateAction {
  static readonly type = '[StripeConnect] ResetStripeConnectStateAction';
}

export class ClearOnboardingUrlAction {
  static readonly type = '[StripeConnect] ClearOnboardingUrlAction';
}
